import script from "./MainSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSideBar.vue?vue&type=script&setup=true&lang=js"

import "./MainSideBar.vue?vue&type=style&index=0&id=1391e4fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1391e4fa"]])

export default __exports__